/* unplugin-vue-components disabled */import { render } from "./noData.vue?vue&type=template&id=24e4f59b&scoped=true"
import script from "./noData.vue?vue&type=script&setup=true&lang=js"
export * from "./noData.vue?vue&type=script&setup=true&lang=js"

import "./noData.vue?vue&type=style&index=0&id=24e4f59b&scoped=true&lang=scss"
/* custom blocks */
import block0 from "./noData.vue?vue&type=custom&index=0&blockType=vue-filename-injector"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_56c7d0d1d885c2cba1c2415451171383/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24e4f59b"],['__file',"src/components/noData.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "24e4f59b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('24e4f59b', __exports__)) {
    api.reload('24e4f59b', __exports__)
  }
  
  module.hot.accept("./noData.vue?vue&type=template&id=24e4f59b&scoped=true", () => {
    api.rerender('24e4f59b', render)
  })

}


export default __exports__